module.exports = __webpack_public_path__ + "img/zhangpin.6dd8c4c6.jpg";